import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
const Login = () => import('@/components/Login')
const SalesOrderList = () => import('@/components/SalesOrderList')
const SalesOrderDetails = () => import('@/components/SalesOrderDetails')
const SalesOrderAddEdit = () => import('@/components/SalesOrderAddEdit')
const SalesOrderPayment = () => import('@/components/SalesOrderPayment')
const SalesOrderPayments = () => import('@/components/SalesOrderPayments')
const ShipmentList = () => import('@/components/ShipmentList')
const ShipmentDetails = () => import('@/components/ShipmentDetails')
const ShipmentEmail = () => import('@/components/ShipmentEmail')
const CategoryList = () => import('@/components/CategoryList')
const SchematicDetails = () => import('@/components/SchematicDetails')
const SchematicList = () => import('@/components/SchematicList')
const MainBannerList = () => import('@/components/MainBannerList')
const MainBannerDetails = () => import('@/components/MainBannerDetails')
const TicketList = () => import('@/components/TicketList')
const TicketDetails = () => import('@/components/TicketDetails')
const TicketCreation = () => import('@/components/TicketCreation')
// const ProductList = () => import('@/components/ProductList')
// const ProductDetails = () => import('@/components/ProductDetails')
const PaymentList = () => import('@/components/PaymentList')
const VoucherTypeList = () => import('@/components/VoucherTypeList')
const VoucherTypeDetails = () => import('@/components/VoucherTypeDetails')
const VoucherCodeList = () => import('@/components/VoucherCodeList')
const CourierShippingRates = () => import('@/components/CourierShippingRates')
const ExpensesAddEdit = () => import('@/components/ExpensesAddEdit')
const IncomesAddEdit = () => import('@/components/IncomesAddEdit')
const TransactionList = () => import('@/components/TransactionList')
const CustomerList = () => import('@/components/CustomerList')
const CustomerDetails = () => import('@/components/CustomerDetails')
const CustomerOrderList = () => import('@/components/CustomerOrderList')
const SellerList = () => import('@/components/SellerList')
const SellerDetails = () => import('@/components/SellerDetails')
const AdminList = () => import('@/components/AdminList')
const AdminDetails = () => import('@/components/AdminDetails')
const SearchLogs = () => import('@/components/SearchLogs')
const UserLogs = () => import('@/components/UserLogs')
const AdminLogs = () => import('@/components/AdminLogs')
const MyProfile = () => import('@/components/MyProfile')
const MyPassword = () => import('@/components/MyPassword')
const ReportSales = () => import('@/components/ReportSales')
const ReportProfit = () => import('@/components/ReportProfit')
const ReportNetProfitByMonth = () => import('@/components/ReportNetProfitByMonth')
const ReportNetProfitByYear = () => import('@/components/ReportNetProfitByYear')
const ReportMiddleRates = () => import('@/components/ReportMiddleRates')

Vue.use(Router)

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/login')
}

// scrollBehavior:
// - only available in html5 history mode
// - defaults to no scroll behavior
// - return false to prevent scroll
const scrollBehavior = function (to, from, savedPosition) {
  if (savedPosition && !to.matched.some(m => m.meta.scrollToTop)) {
    // savedPosition is only available for popstate navigations.
    return savedPosition
  } else {
    const position = {}

    if (to.matched.some(m => m.meta.scrollToTop)) {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      console.log('scroll to top')
      position.x = 0
      position.y = 0
    }

    return position
  }
}

export default new Router({
  scrollBehavior,
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/',
      name: 'Home',
      component: SalesOrderList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/payments',
      name: 'PaymentList',
      component: PaymentList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/payments/:status',
      name: 'PaymentListByStatus',
      props: true,
      component: PaymentList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/payment',
      name: 'AddPayment',
      component: SalesOrderPayment,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    /* {
      path: '/payment/:paymentId',
      name: 'PaymentDetails',
      props: true,
      component: PaymentDetails,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    }, */
    {
      path: '/vouchers',
      name: 'VoucherTypeList',
      component: VoucherTypeList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/voucher',
      name: 'AddVoucherType',
      component: VoucherTypeDetails,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/voucher/:voucherTypeId',
      name: 'VoucherTypeDetails',
      props: true,
      component: VoucherTypeDetails,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/voucher/:voucherTypeId/codes',
      name: 'VoucherCodeList',
      props: true,
      component: VoucherCodeList,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/orders',
      name: 'SalesOrderList',
      component: SalesOrderList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/orders/:status',
      name: 'SalesOrderListByStatus',
      props: true,
      component: SalesOrderList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/order',
      name: 'SalesOrderAdd',
      component: SalesOrderAddEdit,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/order/:salesOrderNo',
      name: 'SalesOrderDetails',
      props: true,
      component: SalesOrderDetails,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/order/:salesOrderNo/edit',
      name: 'SalesOrderEdit',
      props: true,
      component: SalesOrderAddEdit,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/order/:salesOrderNo/payments',
      name: 'SalesOrderPayments',
      props: true,
      component: SalesOrderPayments,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/order/:salesOrderNo/payment',
      name: 'AddSalesOrderPayment',
      props: true,
      component: SalesOrderPayment,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/payment/:paymentId',
      name: 'PaymentEdit',
      props: true,
      component: SalesOrderPayment,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/shipments/:salesOrderNo',
      name: 'ShipmentList',
      props: true,
      component: ShipmentList,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/shipment/email/:deliveryOrderNo',
      name: 'ShipmentEmail',
      props: true,
      component: ShipmentEmail,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/shipment/:deliveryOrderNo',
      name: 'ShipmentDetails',
      props: true,
      component: ShipmentDetails,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/ticket',
      name: 'TicketCreation',
      component: TicketCreation,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/tickets',
      name: 'TicketList',
      component: TicketList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/tickets/:status',
      name: 'TicketListByStatus',
      props: true,
      component: TicketList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/ticket/:ticketId',
      name: 'TicketDetails',
      props: true,
      component: TicketDetails,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/categories',
      name: 'Categories',
      component: CategoryList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/categories/:parentId',
      name: 'CategoriesByParentId',
      props: true,
      component: CategoryList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/schematics',
      name: 'SchematicList',
      component: SchematicList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/schematic',
      name: 'AddSchematic',
      component: SchematicDetails,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/schematic/:schematicId',
      name: 'SchematicById',
      props: true,
      component: SchematicDetails,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/courier/rates',
      name: 'CourierShippingRates',
      component: CourierShippingRates,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/expenses',
      name: 'AddExpenses',
      component: ExpensesAddEdit,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/expenses/:year/:month',
      name: 'EditExpenses',
      props: true,
      component: ExpensesAddEdit,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/incomes',
      name: 'AddIncomes',
      component: IncomesAddEdit,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/incomes/:year/:month',
      name: 'EditIncomes',
      props: true,
      component: IncomesAddEdit,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/customers',
      name: 'CustomerList',
      component: CustomerList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/customer',
      name: 'AddCustomer',
      component: CustomerDetails,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/customer/:userId',
      name: 'CustomerDetails',
      props: true,
      component: CustomerDetails,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/customer/:userId/transactions',
      name: 'CustomerTransactionList',
      props: true,
      component: TransactionList,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/customer/:userId/orders',
      name: 'CustomerOrderList',
      props: true,
      component: CustomerOrderList,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/customer/:userId/orders/:key',
      name: 'CustomerOrderListByStatus',
      props: true,
      component: CustomerOrderList,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/sellers',
      name: 'SellerList',
      component: SellerList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/seller/:userId',
      name: 'SellerDetails',
      props: true,
      component: SellerDetails,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/seller/:userId/transactions',
      name: 'SellerTransactionList',
      props: true,
      component: TransactionList,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    /* {
      path: '/seller/:userId/sales',
      name: 'SellerOrderList',
      props: true,
      component: SellerOrderList,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/seller/:userId/sales/:key',
      name: 'SellerOrderListByStatus',
      props: true,
      component: SellerOrderList
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    }, */
    {
      path: '/admins',
      name: 'AdminList',
      component: AdminList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/admin',
      name: 'AddAdmin',
      component: AdminDetails,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/admin/:adminId',
      name: 'AdminDetails',
      props: true,
      component: AdminDetails,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/me/profile',
      name: 'MyProfile',
      component: MyProfile,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/me/password',
      name: 'MyPassword',
      component: MyPassword,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/report/sales',
      name: 'ReportSales',
      component: ReportSales,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/report/profit',
      name: 'ReportProfit',
      component: ReportProfit,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/report/net-profit/:year/:month',
      name: 'ReportNetProfitByMonth',
      props: true,
      component: ReportNetProfitByMonth,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/report/net-profit/:year',
      name: 'ReportNetProfitByYear',
      props: true,
      component: ReportNetProfitByYear,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/report/middle-rates',
      name: 'ReportMiddleRates',
      component: ReportMiddleRates,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/logs/search',
      name: 'SearchLogs',
      component: SearchLogs,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/logs/user',
      name: 'UserLogs',
      component: UserLogs,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/logs/admin',
      name: 'AdminLogs',
      component: AdminLogs,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/banner/main/list',
      name: 'MainBannerList',
      component: MainBannerList,
      beforeEnter: ifAuthenticated
    },
    {
      path: '/banner/main',
      name: 'AddBanner',
      component: MainBannerDetails,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    },
    {
      path: '/banner/main/:bannerId',
      name: 'MainBannerDetails',
      props: true,
      component: MainBannerDetails,
      beforeEnter: ifAuthenticated,
      meta: { scrollToTop: true }
    }
  ]
})
